import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface AggregateTimeComponentProps {
  className?: string;
  timeSeconds: number;
}

export default class AggregateTimeComponent extends React.Component<AggregateTimeComponentProps> {
  static propTypes = {
    timeSeconds: PropTypes.number.isRequired,
  };

  static formattedTime(timeSeconds: number): string {
    const duration = moment.duration(timeSeconds, 'seconds');
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const time = [];
    if (hours) {
      time.push(`${hours} h`);
    }
    if (minutes) {
      time.push(`${minutes} m`);
    }
    if (seconds) {
      time.push(`${seconds} s`);
    }
    return time.join(', ');
  }

  override render(): JSX.Element {
    return (
      <div
        {...{
          ...this.props,
          className: classNames(this.props.className, 'step-aggregate-time'),
          title: 'Aggregate Time',
        }}
      >
        <BenchlingIcon icon="clock" /> {AggregateTimeComponent.formattedTime(this.props.timeSeconds)}
      </div>
    );
  }
}
